import PolarisIcon from '@/components/_common/PolarisIcon';
import { IngestFile } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import React from 'react';
import IngestRegisterModal from './IngestRegisterModal';
import { IconButton, Tooltip , useTheme } from '@mui/material';

interface IngestRegisterProps {
  data: IngestFile;
}

const IngestRegister = ({ data }: IngestRegisterProps) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const { status } = data;
  const isDisabled = status !== 'ready_for_ingest';
  const theme = useTheme();

  const toggleRegisterModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <>
      <Tooltip
        title={
          isDisabled ? (
            <span>
              File may not be registered until at <Italics>Ready for Ingest</Italics>
            </span>
          ) : (
            'Register File'
          )
        }
      >
        <div>
          <IconButton onClick={toggleRegisterModal} disabled={isDisabled}>
            <PolarisIcon icon="link" height={24} style={{ color: isDisabled ? theme.palette.action.disabled : theme.palette.primary.main }} />
          </IconButton>
        </div>
      </Tooltip>
      {/* doing this double modalOpen so that we don't mount a bunch of these modals since these are on each row */}
      {modalOpen && <IngestRegisterModal open={modalOpen} toggleOpen={toggleRegisterModal} data={data} />}
    </>
  );
};

export default IngestRegister;

const Italics = styled.span`
  font-style: italic;
`;
